import moment from "moment";
import { viandas2Get, viandas2Download } from "../../../common/service/viandas2Client";

export const getConsolidado = (filtros = {}) =>
  viandas2Get("/rrhh/reportes/consolidado", filtros);

export const descargarConsolidadoExcel = (filtros = {}) =>
  viandas2Download("/rrhh/reportes/consolidado/excel", filtros, "consolidado_viandas.xlsx");

export const descargarConsolidadoTxt = (filtros = {}) =>
  viandas2Download("/rrhh/reportes/consolidado/txt", filtros, "consolidado_viandas.txt");

// Exportador dedicado al proveedor COMIDA AL PASO (id 5). El endpoint es fijo:
// no acepta id_proveedor. Solo toma `desde` = lunes de la semana a exportar.
export const descargarReporteComidaAlPaso = (desde) => {
  const lunes = moment(desde, "YYYY-MM-DD").startOf("isoWeek");
  const fechaArchivo = lunes.format("DD-MM-YYYY");
  return viandas2Download(
    "/rrhh/reportes/comida-al-paso",
    { desde: lunes.format("YYYY-MM-DD") },
    `Pedido_ComidaAlPaso_${fechaArchivo}.xlsx`,
  );
};

export const descargarReporteBonfood = (desde, idProveedor = 6) => {
  const fechaArchivo = moment(desde, "YYYY-MM-DD").format("DD-MM-YYYY");
  return viandas2Download(
    "/rrhh/reportes/bonfood",
    { desde, id_proveedor: idProveedor },
    `bonfood_${fechaArchivo}.xlsx`,
  );
};
